import { BackgroundFilter, Icon, Root, Title } from '@/components/tour/game/FinishScreen/styled';

export const FlowsFinishScreen = ({ title, finishScreenImage, backgroundImagePath }) => {
  return (
    <Root backgroundImage={backgroundImagePath}>
      <BackgroundFilter>
        <div className="col-md-6 offset-md-3 pt-5">
          <Icon finishScreenImage={finishScreenImage} />
          <Title>{title}</Title>
        </div>
      </BackgroundFilter>
    </Root>
  );
};
